import React from 'react';
import cx from 'classnames';
import isEqual from 'is-equal';
import buildUrl from 'build-url-ts';
import styles from './userRoleListView.module.scss';
import { Image, Row, Col } from 'react-bootstrap';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';

class UserRoleListView extends React.Component {
  constructor(props) {
    super(props);

    this._handleUserRoleClick = this._handleUserRoleClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
  }

  componentDidMount() {
    this.props.hideSettingsSideMenu();
    this.handleUrlChange(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.location.search, nextProps.location.search)) {
      this.handleUrlChange(nextProps);
    }
  }

  componentWillUnmount() {
    this.props.showSettingsSideMenu();
  }

  handleUrlChange() {
    // this.props.fetchUserRoles();
  }

  _handleUserRoleClick(userRole) {
    this.props.fetchUserRole(userRole.id);
    this.props.hideSettingsSideMenu();
    this.props.invalidateUserSelection();

    var path = buildUrl(null, {
      path: `/settings/user-roles/${userRole.id}`
    });

    this.props.navigate(path);

    if (this.props.onListItemClick) {
      this.props.onListItemClick();
    }
  }

  render() {
    if (!this.props.userRoles) {
      return null;
    }

    return (
      <div>
        {this.props.creating && this._renderCreateNewUserGroup()}
        {this._renderUserRoles()}
      </div>
    );
  }

  _renderCreateNewUserGroup() {
    return (
      <div className={cx(styles.userRoleRow, styles.selected)}
        key="new">
        <Row className={styles.metadata}>
          <Col md={this.props.showSettingsMenu ? 6 : 12} className={styles.groupName}>
            <span>{this.localizedCommons.untitled}</span>
          </Col>
        </Row>
      </div>
    )
  }

  _renderUserRoles() {
    if ((!this.props.userRoles || this.props.userRoles.length == 0) && this.props.loading) {
      return this._renderLoading();
    }

    var rows = Array();

    this.props.userRoles.forEach((userRole, index) => {
      rows.push(
        <div className={cx(styles.userRoleRow, { [styles.selected]: userRole.id === this.props.selectedId })}
          key={userRole.id}
          onClick={this._handleUserRoleClick.bind(this, userRole)}>
          <Row className={styles.metadata}>
            <Col md={this.props.showSettingsMenu ? 6 : 12} className={styles.groupName}>
              <span>{userRole.name}</span>
            </Col>
          </Row>
        </div>
      )
    })

    return rows;
  }

  _renderLoading() {
    return (
      <div className={styles.loading}>
        <LoadingMessage
          className={styles.loadingInner}
          message={`${this.localizedCommonLoading.users}...`}
          visible={true} />
      </div>
    )
  }
}

export default UserRoleListView;